import page from './EventList.vue';
export default page;


// WEBPACK FOOTER //
// ./src/components/page/event-list/index.js